import { render, staticRenderFns } from "./CommonChatSettingsModal.vue?vue&type=template&id=6704b20b&scoped=true&"
import script from "./CommonChatSettingsModal.vue?vue&type=script&lang=js&"
export * from "./CommonChatSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./CommonChatSettingsModal.vue?vue&type=style&index=0&id=6704b20b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6704b20b",
  null
  
)

export default component.exports